import Image from "next/image";

const ButtonFilled = (props) => {
  const {
    type,
    title,
    mw,
    borderRadius,
    padding,
    onClick,
    isDisabled,
    buttonColor = "bg-blue hover:text-blue hover:bg-white",
    icon,
    rightIcon,
    margin = "m-2",
    color = "text-white",
    style,
  } = props;

  return (
    <button
      type={type}
      disabled={isDisabled}
      className={`flex justify-center items-center gap-2 
      ${!borderRadius ? "rounded-md" : borderRadius} ${margin} shadow-sm font-bold mt-4 px-3 p-2 ${mw} ${padding} 
      ${isDisabled ? "bg-gray-300" : `${buttonColor} hover:outline outline-2`} ${style} ${color}`}
      onClick={!isDisabled ? onClick : null}
    >
      {icon && (
        <Image src={icon} alt="icon svg" height={30} width={30} className="h-[30px] w-auto" />
      )}
      {title}
      {rightIcon && (
        <Image
          src={rightIcon}
          alt="right icon svg"
          height={12}
          width={12}
          className={`h-3 w-auto rtl:rotate-180 ${color}`}
        />
      )}
    </button>
  );
};

export default ButtonFilled;
